import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { map } from 'rxjs/operators';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { QueryResult } from 'src/app/modules/core/store/models/query.model';
import { Document } from '../store/models';
import { DatasetsRequest } from '../store/models/dataset.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({ providedIn: 'root' })
export class GeofenceService {
  public geofenceDatasets$: BehaviorSubject<Dataset[]> = new BehaviorSubject(null);
  public isInitialized: boolean = false;

  constructor(private http: HttpService) {}

  getGeofenceDatasets(): void {
    const datasetsRequest = {
      skip: 0,
      take: 1000,
      sortField: 'Name',
      sortDirection: 'Ascending',
      where: 'Type==12',
      includeWorkflow: false,
      skipChildren: true
    } as DatasetsRequest;

    const url = `${apiBaseUrl}/v1/meta/datasets/query`;

    this.http.post(url, datasetsRequest).subscribe((results: QueryResult<Dataset>) => {
      this.geofenceDatasets$.next(results.data);
    });

    this.isInitialized = true;
  }

  getGeofenceDocuments(datasetUId: string): Observable<Document[]> {
    const queryString = this.http.queryStringFromObject({
      includeCount: false,
      forceWriteConnection: false
    });

    const body = {
      filterGroup: {
        filters: [],
        filterGroups: [],
        groupType: 1
      },
      calcFields: [],
      fields: 'uid,name',
      sort: 'name',
      pagination: {
        skip: 0,
        take: 1000
      }
    };

    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/query?${queryString}`;

    return this.http.post(url, body).pipe(map((results: QueryResult<Document>) => results.data));
  }
}
